var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeUnfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.98633 12.2333L7.05299 13.8333C7.31966 14.1 7.91966 14.2333 8.31966 14.2333H10.853C11.653 14.2333 12.5197 13.6333 12.7197 12.8333L14.3197 7.96667C14.653 7.03333 14.053 6.23333 13.053 6.23333H10.3863C9.98633 6.23333 9.65299 5.9 9.71966 5.43333L10.053 3.3C10.1863 2.7 9.78633 2.03333 9.18633 1.83333C8.65299 1.63333 7.98633 1.9 7.71966 2.3L4.98633 6.36667",
    stroke: "#1E5AD2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58691 12.2333V5.70002C1.58691 4.76668 1.98691 4.43335 2.92025 4.43335H3.58691C4.52025 4.43335 4.92025 4.76668 4.92025 5.70002V12.2333C4.92025 13.1667 4.52025 13.5 3.58691 13.5H2.92025C1.98691 13.5 1.58691 13.1667 1.58691 12.2333Z",
    stroke: "#1E5AD2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeUnfill);
export default __webpack_public_path__ + "static/media/like-unfill.ba3d229a8bb78c3e42f6f502e1720a45.svg";
export { ForwardRef as ReactComponent };